export function calculateCategory(value: number, thresholds: number[]) {
  if (value < thresholds[0]) {
    return 'very_low';
  } else if (value < thresholds[1]) {
    return 'low';
  } else if (value < thresholds[2]) {
    return 'mid';
  } else if (value < thresholds[3]) {
    return 'high';
  } else {
    return 'very_high';
  }
}
